import { useSelector } from "react-redux";

import PopupFormWrapper from "../popupFormWrapper";
import { GOALS } from "../../../../utils/tracking";

const FORM_CODE = "orderInstall";

export default function OrderInstall() {
  // keep selector side-effect-free; contacts are not needed after removing select list
  useSelector((state) => state.contacts);

  return (
    <PopupFormWrapper
      code={FORM_CODE}
      filterField={({ CODE }) => CODE !== "form_text_31"}
      goalOpen={GOALS.orderInstallOpen}
      extraData={({ popupData }) =>
        popupData ? { form_text_31: popupData } : null
      }
      successText="Заявка отправлена."
      goalSent={GOALS.orderInstallSent}
    />
  );
}
